import "../styles/Home.css";

export default function Home() {
  return (
    <div className="app">
      <h1 className="app-title">pInk comics</h1>
      <p className="app-description">
        Em manutenção. Enquanto nosso site não fica pronto, acesse nosso grupo no <a href="https://t.me/comicspink" rel="noreferrer noopener">Telegram</a>
      </p>
    </div>
  )
}
